import { render } from "./manage-partner.vue?vue&type=template&id=3f38ee99"
import script from "./manage-partner.vue?vue&type=script&lang=js"
export * from "./manage-partner.vue?vue&type=script&lang=js"

import "./manage-partner.vue?vue&type=style&index=0&id=3f38ee99&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__